import React, { useState, useEffect } from 'react';
import { I18n } from 'aws-amplify';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import {
  isNumberAllowDecimalNotMinus,
  getNumDecimalPlace
} from '../../util/numberUtil.js';

function CalcTable(props) {
  const [isVacantOver, setIsVacantOver] = useState(false);
  const [isVacantPrice, setIsVacantPrice] = useState(false);
  const [isInvalidOver, setIsInvalidOver] = useState(false);
  const [isInvalidPrice, setIsInvalidPrice] = useState(false);

  useEffect(() => {
    const hasVacantValue = (mode, setting) => {
      for (let i = 0; i < setting.length; i++) {
        if (setting[i][mode] === '') {
          return true;
        }
      }
      return false;
    }
    const hasInvalidValue = (mode, setting) => {
      const borderNum = mode === 'over' ? 0 : 2;
      for (let i = 0; i < setting.length; i++) {
        if (!validNum(setting[i][mode], borderNum)) {
          return true;
        }
      }
      return false;
    }
    if (props.disabled) {
      setIsVacantOver(false);
      setIsInvalidOver(false);
      setIsVacantPrice(false);
      setIsInvalidPrice(false);
      return;
    }
    setIsVacantOver(hasVacantValue('over', props.setting));
    setIsInvalidOver(hasInvalidValue('over', props.setting));
    setIsVacantPrice(hasVacantValue('unitPrice', props.setting));
    setIsInvalidPrice(hasInvalidValue('unitPrice', props.setting));
  }, [props.setting, props.disabled])
  const update = (e, index, target) => {
    const {value} = e.target;
    // 入力NGの値は弾く
    if (!props.validateAsEntryData(value)) {
      return;
    }
    // そうでなければ入力値として画面反映する
    const s = JSON.parse(JSON.stringify(props.setting));
    s[index][target] = value;
    props.setSetting(s);
  }
  const validNum = (x, border) => {
    // 不正な数値でかつ小数点以下桁数が border 以上であれば
    return (isNumberAllowDecimalNotMinus(x) && (getNumDecimalPlace(x) <= border));
  }
  const changeRowsNum = (e, targetTableName) => {
    const {value} = e.target;
    props.setRows(Number(value));
  }
  const updateTableTitle = () => {
    switch (props.keyStr) {
      case 'buy':
        return 'Purchased energy';
      case 'selfConsumption':
        return 'Self energy consumption';
      case 'consumption':
        return 'Energy consumption';
      default:
        return '';
    }
  }

  // render ===
  const makeOptions = () => {
    const options = [];
    // 選択肢は最低1行で最大10行
    for (let i = 1; i <= props.options; i++) {
      options.push(<option key={String(i)} value={i}>{String(i)}</option>);
    }
    return options;
  }
  const makeRows = () => {
    const zeroKeyStr = `${props.keyStr}condition0`;
    const rowsElem = [
      <TableRow key={zeroKeyStr}>
        <TableCell className="tItem noItem">1</TableCell>
        <TableCell className="tItem">0 kWh {I18n.get('or more')}</TableCell>
        <TableCell className='tItem'>
          <input
            type="text"
            value={props.setting[0].unitPrice}
            onChange={(e) => update(e, 0, 'unitPrice')}
            disabled={props.disabled}
            step={"0.01"}
          />{I18n.get('yen')}
        </TableCell>
      </TableRow>
    ];
    // 選択肢は最低1行で最大10行
    for (let i = 1; i < props.setting.length; i++) {
      const keyStr = `${props.keyStr}condition${i}`;
      rowsElem.push(
        <TableRow key={keyStr}>
          <TableCell className="tItem noItem">{String(i + 1)}</TableCell>
          <TableCell className='tItem'>
            <input
              type="text"
              value={props.setting[i].over}
              onChange={(e) => update(e, i, 'over')}
              disabled={props.disabled}
              step={"1"}
            />kWh {I18n.get('exceed')}
          </TableCell>
          <TableCell className='tItem'>
            <input
              type="text"
              value={props.setting[i].unitPrice}
              onChange={(e) => update(e, i, 'unitPrice')}
              disabled={props.disabled}
              step={"0.01"}
            />{I18n.get('yen')}
          </TableCell>
        </TableRow>
      );
    }
    return rowsElem;
  }
  const updateRows = () => {
    const settingAry = []
    for(let i = 0; i < props.rows; i++) {
      settingAry.push({
        over: '',
        unitPrice: ''
      });
    }
    const num = props.rows < props.setting.length ? props.rows : props.setting.length;
    for(let i = 0; i < num; i++) {
      settingAry[i] = props.setting[i];
    }
    props.setSetting(settingAry);
  }
  return (
    <div className="pricingTable">
      <p>{I18n.get('Unit price setting')}: <span>{I18n.get(updateTableTitle())}</span></p>
      <div className={window.LAPLACEID_LOCALE === 'ja' ? "rowCount" : "rowCount ppaRowCountEn"}>
        <p>{I18n.get('Number of conditions (lines)')}:</p>
        <div className="ppaAssetSelector">
          <select value={props.rows} onChange={(e) =>changeRowsNum(e)} disabled={props.disabled}>
            {makeOptions()}
          </select>
        </div>
        <button className="editButton blue small" onClick={updateRows} disabled={props.disabled}>変更</button>
      </div>
      <Table className="productTable">
        <TableHead>
          <TableRow className="trItem">
          <TableCell className="tItem noItem">{I18n.get('Condition')}</TableCell>
          <TableCell className="tItem">{I18n.get('Break point of the amount of power')}</TableCell>
          <TableCell className="tItem">{I18n.get('Unit price of the amount of power')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {props.setting.length > 0 ? makeRows() : <TableRow />}
        </TableBody>
      </Table>

      {isVacantOver ? <p className="errorText">{I18n.get('Set Break point of the amount of power')}</p> : <p />}
      {isVacantPrice ? <p className="errorText">{I18n.get('Set the unit price of the amount of power')}</p> : <p />}
      {isInvalidOver ? <p className="errorText">{I18n.get('Break point of the amount of power: Please enter the correct format (numbers or a positive integer)')}</p> : <p />}
      {isInvalidPrice ? <p className="errorText">{I18n.get('Unit price of the amount of power: Please enter in the correct format (numbers, periods or two decimal places)')}</p> : <p />}
    </div>
  );
}

export default CalcTable;
